import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
    Accordion, AccordionBody,
    AccordionHeader,
    Button,
    Card,
    CardBody,
    CardHeader, Dialog, DialogBody, DialogFooter, DialogHeader,
    Input, Radio,
    Textarea,
    Typography
} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import {NumericFormat} from "react-number-format";
import {PrinterIcon} from "@heroicons/react/24/solid";
import {CheckIcon} from "@heroicons/react/16/solid";
import InputMask from "react-input-mask";
import MapComponentSearch from "../../shared/map_component_search";
import axios from "axios";

const ValueReduction = ({lot, movement}) => {
    const [loaderActive, setLoaderActive] = useState(false);
    const [nameContributor, setNameContributor] = useState("");
    const [pLastNameContributor, setPLastNameContributor] = useState("");
    const [mLastNameContributor, setMLastNameContributor] = useState("");
    const [error, setError] = useState(null);
    const [contributorValue, setContributorValue] = useState({
        name: "",
        parental_last_name: "",
        maternal_last_name: "",
        phone: "",
        rfc: "",
        contributor_type: "",
        street: "",
        ext_num: "",
        int_num: "",
        neighborhood: "",
        postal_code: "",
        notes: "",
    });
    const [contributorsResult, setContributorsResult] = useState([]);
    const [contributorExisted, setContributorExisted] = useState(false);
    const [openUserInfo, setOpenUserInfo] = useState(false);
    const [openNewUser, setOpenNewUser] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [place, setPlace] = useState({})
    const [openAccordion, setOpenAccordion] = useState(null);
    const [lotNotes, setLotNotes] = useState("");
    const [constructions, setConstructions] = useState([]);
    const [lands, setLands] = useState(null);
    const [lotData, setLotData] = useState([]);
    const [constValues, setConstValues] = useState([]);
    const [constDevaluations, setConstDevaluations] = useState([]);

    useLayoutEffect(() => {
        setLotData(lot);
        setLotNotes(lot.notes);
    }, [lot]);

    useEffect(() => {
        if (Object.keys(place).length > 0) {
            setAddressFields(place.address_components, place.geometry);
        }
    }, [place]);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    useEffect(() => {
        async function fetchLotDetails() {
            try {
                const [constructionsResponse, landResponse] = await Promise.all([
                    fetch(`/lots/${lot.parcel_code}/constructions.json`),
                    fetch(`/lots/${lot.parcel_code}/land.json`),
                ]);

                if (constructionsResponse.ok) {
                    const constructionsData = await constructionsResponse.json();
                    setConstructions(constructionsData);
                } else {
                    console.log("No se encontraron construcciones para este código.");
                }

                if (landResponse.ok) {
                    const landData = await landResponse.json();
                    setLands(landData);

                } else {
                    console.log("No se encontraron terrenos para este código.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        async function fetchRates() {
            try {
                const [valuesResponse, devaluationsResponse] = await Promise.all([
                    fetch(`/construction_values.json`),
                    fetch(`/construction_devaluations.json`),
                ]);

                if (valuesResponse.ok) {
                    const constValuesData = await valuesResponse.json();
                    setConstValues(constValuesData);
                } else {
                    console.log("No se encontraron construcciones para este código.");
                }

                if (devaluationsResponse.ok) {
                    const devaluationsData = await devaluationsResponse.json();
                    setConstDevaluations(devaluationsData);

                } else {
                    console.log("No se encontraron terrenos para este código.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        fetchLotDetails();
        fetchRates();
    }, []);

    const setAddressFields = (addressComponents, geometry) => {
        const street = getAddressComponentByType(addressComponents, 'route');
        const numStreet = getAddressComponentByType(addressComponents, 'street_number');
        const neighborhood = getAddressComponentByType(addressComponents, 'sublocality');
        const postalCode = getAddressComponentByType(addressComponents, 'postal_code');

        const lat = geometry.location.lat();
        const lng = geometry.location.lng();

        setContributorValue({
            ...contributorValue, street: street, ext_num: numStreet, neighborhood: neighborhood,
            postal_code: postalCode, contributor_lat: lat, contributor_lng: lng
        });
    };

    const getAddressComponentByType = (addressComponents, type) => {
        const component = addressComponents.find(component => component.types.includes(type))

        return component ? component.long_name : "";
    };

    const handleReset = () => {
        window.location.replace('movements');
    };

    const handleChangeConstValue = (id, valueId) => {
        const newValId = parseInt(valueId);
        const constValue = constValues.find(item => item.id === newValId);
        if (!constValue) return;

        setConstructions(prevConstructions =>
            prevConstructions.map((item) => {
                if (item.construction_id === id) {
                    const updatedItem = {
                        ...item,
                        construction_value_id: newValId,
                        description: constValue.description,
                        value_per_m2: constValue.value_per_m2,
                    };
                    updatedItem.valuation = Number(updatedItem.area) * Number(constValue.value_per_m2) * Number(updatedItem.devaluation_rate);
                    return updatedItem;
                }
                return item;
            })
        );
    };

    const handleChangeConstDeval = (id, devalId) => {
        const newDevalId = parseInt(devalId);
        const devaluation = constDevaluations.find(item => item.id === newDevalId);
        if (!devaluation) return;

        setConstructions(prevConstructions =>
            prevConstructions.map((item) => {
                if (item.construction_id === id) {
                    const updatedItem = {
                        ...item,
                        construction_devaluation_id: newDevalId,
                        devaluation_rate: devaluation.devaluation_rate,
                    };
                    updatedItem.valuation = Number(updatedItem.area) * Number(updatedItem.value_per_m2) * Number(devaluation.devaluation_rate);
                    return updatedItem;
                }
                return item;
            })
        );
    };

    const handleEditConstruction = (id, field, value) => {
        const updatedData = constructions.map((item) => {
            if (item.construction_id === id) {
                const updatedItem = {...item, [field]: value};

                updatedItem.valuation = updatedItem.area * updatedItem.value_per_m2 * updatedItem.devaluation_rate;

                return updatedItem;
            }
            return item;
        });

        setConstructions(updatedData);
    };

    const handleEditLand = (id, field, value) => {
        const updatedData = lands.map((item) => {
            if (item.id === id) {
                const updatedItem = {...item, [field]: value};

                updatedItem.valuation = updatedItem.area * updatedItem.land_value_per_m2 * updatedItem.devaluation_rate;

                return updatedItem;
            }
            return item;
        });

        setLands(updatedData);
    };

    const handleSubmit = async () => {
        try {
            setLoaderActive(true);
            console.log('Constructions: ', constructions);
            const response = await axios.post(`lots/${lot.parcel_code}/values_change.json`, {
                constructions: constructions,
                lot: {
                    notes: lotNotes,
                    reason_type_id: movement.id,
                    special_facilities_value: lotData.special_facilities_value,
                    special_facilities: lotData.special_facilities,
                    effective_bimester: lotData.effective_bimester,
                    effective_year: lotData.effective_year,
                    calculate_qualification: true,
                    calculate_debt: true,
                },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const current_lot_url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(current_lot_url, '_blank');
                setLoaderActive(false);
            } else {
                setError('Error al actualizar valores del predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        }
    }

    const totalConstArea = constructions.reduce((acc, construction) => acc + parseInt(construction.area), 0);
    const totalConstValue = constructions.reduce((acc, construction) => acc + construction.valuation, 0);

    const totalLandArea = lands ? lands.reduce((acc, land) => acc + parseInt(land.area), 0) : 0;
    const totalLandValue = lands ? lands.reduce((acc, land) => acc + land.valuation, 0) : 0;

    const totalLandValuation = lands ? lands.reduce((acc, land) => acc + land.valuation, 0) : 0;
    const totalConstValuation = constructions.reduce((acc, construction) => acc + construction.valuation + parseInt(lotData.special_facilities_value), 0);
    const getUnit = lot.lot_location_type === 'URBANO' ? <>m<sup>2</sup></> : <>ha</>;

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <CardBody className='p-0'>
                                <div className="w-full mb-4 bg-gray-100">
                                    {lot.latitude && lot.longitude ? (
                                        <MapComponent
                                            parcel_code={lot.parcel_code}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                        />
                                    ) : (
                                        <MapComponent/>
                                    )}
                                </div>

                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Dirección
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                                            C.P. {lot.postal_code}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Referencias
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.address_references === null ? '' : lot.address_references}
                                        </Typography>
                                    </div>
                                </div>

                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    REGISTRO DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    R.P.P.
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Insc.
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.inscription}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Folio
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.folio}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Libro
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.book}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha efecto
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Input value={lotData.effective_bimester}
                                                               onChange={(e) => setLotData({
                                                                   ...lotData,
                                                                   effective_bimester: e.target.value,
                                                               })}
                                                               label={'Bim'}
                                                               containerProps={{
                                                                   className: '!min-w-0'
                                                               }}
                                                        />
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Input value={lotData.effective_year}
                                                               onChange={(e) => setLotData({
                                                                   ...lotData,
                                                                   effective_year: e.target.value,
                                                               })}
                                                               label={'Año'}
                                                               containerProps={{
                                                                   className: '!min-w-0'
                                                               }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha exento
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    PROPIETARIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            {lot.contributor_type === 'P' ? (
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Nombre
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.name}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Apellido paterno
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.parental_last_name}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Apellido Materno
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.maternal_last_name}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Razón social
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.name}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )}
                                            <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                <div className='flex flex-col w-full'>
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        Dirección
                                                    </Typography>
                                                    <Typography
                                                        variant="paragraph"
                                                        className="font-medium"
                                                    >
                                                        {lot.contributor_street}
                                                        {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                        {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                        {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                                    </Typography>
                                                </div>
                                                <div className='flex flex-col w-full'>
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        Teléfono
                                                    </Typography>
                                                    <Typography
                                                        variant="paragraph"
                                                        className="font-medium"
                                                    >
                                                        {lot.phone ? lot.phone : 'N/A'}
                                                    </Typography>
                                                </div>
                                                <div className='flex flex-col w-full'>
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        RFC
                                                    </Typography>
                                                    <Typography
                                                        variant="paragraph"
                                                        className="font-medium"
                                                    >
                                                        {lot.rfc ? lot.rfc : 'N/A'}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-auto py-10 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Valores de predio
                </h6>
                <div className="flex flex-row gap-4 border border-blue-gray-100 p-4 rounded-b-lg">
                    <div className='w-full'>
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            TERRENO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardBody className='p-0'>
                                            {lot.lot_location_type === 'URBANO' ? (
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    {(Array.isArray(lands) && lands.length > 0) && (
                                                        <>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Superficie
                                                                </Typography>
                                                                <div
                                                                    className="flex flex-row justify-center gap-1"
                                                                >
                                                                    <Typography
                                                                        variant="paragraph"
                                                                        className="font-medium"
                                                                    >
                                                                        {lands[0].area}
                                                                        <span className='py-2'>{getUnit}</span>
                                                                    </Typography>

                                                                </div>
                                                                {/*<div*/}
                                                                {/*    className="flex flex-row justify-center gap-1"*/}
                                                                {/*>*/}
                                                                {/*    <Input value={lands[0].area}*/}
                                                                {/*           onChange={(e) => handleEditLand(lands[0].id, 'area', e.target.value)}*/}
                                                                {/*           containerProps={{*/}
                                                                {/*               className: '!min-w-0 max-w-[50%]'*/}
                                                                {/*           }}*/}
                                                                {/*           className='text-center'*/}
                                                                {/*    />*/}
                                                                {/*    <span className='py-2'>{getUnit}</span>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Valor del terreno
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    <NumericFormat
                                                                        value={lands[0].valuation.toFixed(2)}
                                                                        displayType={'text'}
                                                                        prefix={'$'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    />
                                                                </Typography>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                <table className="w-full min-w-[640px] table-auto border">
                                                    <thead>
                                                    <tr className='bg-gray-50'>
                                                        {["Cve. Val.", "Descripción", "Superficie", "Valor"].map(
                                                            (el) => (
                                                                <th
                                                                    key={el}
                                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                >
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        {el}
                                                                    </Typography>
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(!lands || lands.length === 0) ? (
                                                        <tr className="w-full">
                                                            <td colSpan="100%" className="text-center py-3">
                                                                <strong>El predio no cuenta con terrenos
                                                                    registrados.</strong>
                                                            </td>
                                                        </tr>
                                                    ) : (lands.map((land, index) => {
                                                            const className = `py-3 px-5 ${
                                                                index === land.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;
                                                            return (
                                                                <tr key={land.id}
                                                                    className="hover:bg-gray-50 cursor-pointer">
                                                                    <td className={className}>{land.rustic_land_value_id}</td>
                                                                    <td className={className}>{land.rustic_land_desc}</td>
                                                                    <td className={className}>
                                                                        <NumericFormat
                                                                            value={land.area.toFixed(4)}
                                                                            displayType={'text'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        /> {getUnit}
                                                                    </td>
                                                                    <td className={className}>
                                                                        <NumericFormat
                                                                            value={land.value.toFixed(2)}
                                                                            displayType={'text'}
                                                                            prefix={'$'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                    </tbody>
                                                    <tfoot>
                                                    <tr className='border-t'>
                                                        <td colSpan='2'
                                                            className='py-3 px-5 text-right border-r'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Totales
                                                            </Typography>
                                                        </td>
                                                        <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                            <NumericFormat
                                                                value={totalLandArea.toFixed(4)}
                                                                displayType={'text'}
                                                                allowLeadingZeros
                                                                thousandSeparator=","
                                                            /> {getUnit}
                                                        </td>
                                                        <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b border-r'>
                                                            <NumericFormat
                                                                value={totalLandValue.toFixed(2)}
                                                                displayType={'text'}
                                                                prefix={'$'}
                                                                allowLeadingZeros
                                                                thousandSeparator=","
                                                            />
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            )}
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            CONSTRUCCIONES
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardBody className='p-0'>
                                            <table className="w-full min-w-[640px] table-auto">
                                                <thead>
                                                <tr className='bg-gray-50'>
                                                    {["Cve. Valuación", "Edad", "Sup. Construcción", "Valor"].map(
                                                        (el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        )
                                                    )}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {(!constructions || constructions.length === 0) ? (
                                                    <tr className="w-full">
                                                        <td colSpan="100%" className="text-center py-3">
                                                            <strong>El predio no cuenta con
                                                                construcciones.</strong>
                                                        </td>
                                                    </tr>
                                                ) : (constructions.map((construction, index) => {
                                                        const className = `py-3 px-5 ${
                                                            index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                        }`;
                                                        return (
                                                            <tr key={construction.construction_id}
                                                                className="hover:bg-gray-50 cursor-pointer">
                                                                <td className={className}>
                                                                    <select
                                                                        value={construction.construction_value_id}
                                                                        onChange={(e) => handleChangeConstValue(construction.construction_id, e.target.value)}
                                                                        className="w-full rounded-[7px] border-blue-gray-200"
                                                                    >
                                                                        {constValues.map((constValue) => (
                                                                            <option key={constValue.id}
                                                                                    value={constValue.id}>
                                                                                {constValue.id} - {constValue.description}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td className={className}>
                                                                    <select
                                                                        value={construction.construction_devaluation_id.toString()}
                                                                        onChange={(e) => handleChangeConstDeval(construction.construction_id, e.target.value)}
                                                                        className="w-full text-center rounded-[7px] border-blue-gray-200"
                                                                    >
                                                                        {constDevaluations.map((constDevaluation) => (
                                                                            <option
                                                                                key={constDevaluation.id.toString()}
                                                                                value={constDevaluation.id.toString()}>
                                                                                {constDevaluation.id}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td className={className}>
                                                                    <div
                                                                        className="flex flex-row gap-1"
                                                                    >
                                                                        <Input
                                                                            value={construction.area}
                                                                            onChange={(e) => handleEditConstruction(construction.construction_id, "area", e.target.value)}
                                                                            containerProps={{
                                                                                className: '!min-w-0 max-w-[25%] border-0'
                                                                            }}
                                                                            className='border-0 focus:!border-0 focus:outline-0 focus:ring-0'
                                                                            variant="static"
                                                                        />
                                                                        <span
                                                                            className='py-2'>m<sup>2</sup></span>
                                                                    </div>
                                                                </td>
                                                                <td className={className}>
                                                                    <NumericFormat
                                                                        value={construction.valuation.toFixed(2)}
                                                                        displayType={'text'}
                                                                        prefix={'$'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                )}

                                                </tbody>
                                                <tfoot>
                                                <tr className='border-t'>
                                                    <td colSpan='2' className='py-3 px-5 text-right border-r'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Totales
                                                        </Typography>
                                                    </td>
                                                    <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                        <NumericFormat
                                                            value={totalConstArea}
                                                            displayType={'text'}
                                                            thousandSeparator=","
                                                        /> m<sup>2</sup>
                                                    </td>
                                                    <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b border-r'>
                                                        <NumericFormat
                                                            value={totalConstValue.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                            <div
                                                className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                <div
                                                    className='flex flex-col w-full p-4 place-content-center'>
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        Instalaciones especiales
                                                    </Typography>
                                                    <div
                                                        className="flex flex-row justify-center gap-1"
                                                    >
                                                        <span className='py-2'>$</span>
                                                        <Input value={lotData.special_facilities_value}
                                                               onChange={(e) => setLotData({
                                                                   ...lotData,
                                                                   special_facilities_value: e.target.value,
                                                               })}
                                                               containerProps={{
                                                                   className: '!min-w-0 max-w-[50%]'
                                                               }}
                                                               className='text-center bg-white'
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className={`flex flex-col w-full p-4 ${lot.special_facilities && 'border rounded-md bg-gray-50'}`}>
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        Descripción de instalaciones especiales
                                                    </Typography>
                                                    <Typography
                                                        variant="paragraph"
                                                        className="font-medium"
                                                    >
                                                        <Textarea
                                                            type="text"
                                                            className="bg-white"
                                                            value={lotData.special_facilities}
                                                            onChange={(e) => setLotData({
                                                                ...lotData,
                                                                special_facilities: e.target.value,
                                                            })}
                                                            rows="6"
                                                        ></Textarea>
                                                    </Typography>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            AVALÚO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardHeader className='bg-transparent' shadow={false}>
                                        </CardHeader>
                                        <CardBody className='p-0'>
                                            <div className='mb-6'>
                                                {lot.lot_location_type === 'URBANO' ? (
                                                    (!lands || lands[0].corridor_value > 0) ? (
                                                        <>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                            >
                                                                Valores Corredor
                                                            </Typography>
                                                            <table
                                                                className="w-full min-w-[640px] table-auto border">
                                                                <thead>
                                                                <tr className='bg-gray-50'>
                                                                    {["Sup. Terreno", "Val. Corr. X m2", "Factor", "Valor"].map(
                                                                        (el) => (
                                                                            <th
                                                                                key={el}
                                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                            >
                                                                                <Typography
                                                                                    variant="small"
                                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                                >
                                                                                    {el}
                                                                                </Typography>
                                                                            </th>
                                                                        )
                                                                    )}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {(!lands || lands.length === 0) ? (
                                                                    <tr className="w-full">
                                                                        <td colSpan="100%"
                                                                            className="text-center py-3">
                                                                            <strong>El predio no cuenta con
                                                                                terrenos
                                                                                registrados.</strong>
                                                                        </td>
                                                                    </tr>
                                                                ) : (lands.map((land, index) => {
                                                                        const className = `py-3 px-5 ${
                                                                            index === land.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                        }`;
                                                                        return (
                                                                            <tr key={land.id}
                                                                                className="hover:bg-gray-50 cursor-pointer">
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.area.toFixed(2)}
                                                                                        displayType={'text'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    /> {getUnit}
                                                                                </td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.corridor_value.toFixed(2)}
                                                                                        displayType={'text'}
                                                                                        prefix={'$'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    />
                                                                                </td>
                                                                                <td className={className}>{land.corridor_factor}</td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.valuation.toFixed(2)}
                                                                                        displayType={'text'}
                                                                                        prefix={'$'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                            >
                                                                Terreno Urbano
                                                            </Typography>
                                                            <table
                                                                className="w-full min-w-[640px] table-auto border">
                                                                <thead>
                                                                <tr className='bg-gray-50'>
                                                                    {["Sup. Terreno", "Z. Homo.", "Val. X m2", "Factor", "Demerito", "Valor"].map(
                                                                        (el) => (
                                                                            <th
                                                                                key={el}
                                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                            >
                                                                                <Typography
                                                                                    variant="small"
                                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                                >
                                                                                    {el}
                                                                                </Typography>
                                                                            </th>
                                                                        )
                                                                    )}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {(!lands || lands.length === 0) ? (
                                                                    <tr className="w-full">
                                                                        <td colSpan="100%"
                                                                            className="text-center py-3">
                                                                            <strong>El predio no cuenta con
                                                                                terrenos
                                                                                registrados.</strong>
                                                                        </td>
                                                                    </tr>
                                                                ) : (lands.map((land, index) => {
                                                                        const className = `py-3 px-5 ${
                                                                            index === land.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                        }`;
                                                                        return (
                                                                            <tr key={land.id}
                                                                                className="hover:bg-gray-50 cursor-pointer">
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.area}
                                                                                        displayType={'text'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    /> {getUnit}
                                                                                </td>
                                                                                <td className={className}>{land.zone_name}</td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.land_value_per_m2}
                                                                                        displayType={'text'}
                                                                                        prefix={'$'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    />
                                                                                </td>
                                                                                <td className={className}>{land.factor}</td>
                                                                                <td className={className}>{land.devaluation_rate}</td>
                                                                                <td className={className}>
                                                                                    <NumericFormat
                                                                                        value={land.valuation.toFixed(2)}
                                                                                        displayType={'text'}
                                                                                        prefix={'$'}
                                                                                        allowLeadingZeros
                                                                                        thousandSeparator=","
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    )
                                                ) : (
                                                    <>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                        >
                                                            Terreno Rural
                                                        </Typography>
                                                        <table
                                                            className="w-full min-w-[640px] table-auto border">
                                                            <thead>
                                                            <tr className='bg-gray-50'>
                                                                {["Cve. Val.", "Descripción", "Superficie", "Val. x Ha", "Factor", "Valor"].map(
                                                                    (el) => (
                                                                        <th
                                                                            key={el}
                                                                            className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                        >
                                                                            <Typography
                                                                                variant="small"
                                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                            >
                                                                                {el}
                                                                            </Typography>
                                                                        </th>
                                                                    )
                                                                )}
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {(!lands || lands.length === 0) ? (
                                                                <tr className="w-full">
                                                                    <td colSpan="100%"
                                                                        className="text-center py-3">
                                                                        <strong>El predio no cuenta con terrenos
                                                                            registrados.</strong>
                                                                    </td>
                                                                </tr>
                                                            ) : (lands.map((land, index) => {
                                                                    const className = `py-3 px-5 ${
                                                                        index === land.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                    }`;
                                                                    return (
                                                                        <tr key={land.id}
                                                                            className="hover:bg-gray-50 cursor-pointer">
                                                                            <td className={className}>{land.rustic_land_value_id}</td>
                                                                            <td className={className}>{land.rustic_land_desc}</td>
                                                                            <td className={className}>
                                                                                <NumericFormat
                                                                                    value={land.area.toFixed(2)}
                                                                                    displayType={'text'}
                                                                                    allowLeadingZeros
                                                                                    thousandSeparator=","
                                                                                /> {getUnit}
                                                                            </td>
                                                                            <td className={className}>
                                                                                <NumericFormat
                                                                                    value={land.value_per_h2.toFixed(2)}
                                                                                    displayType={'text'}
                                                                                    prefix={'$'}
                                                                                    allowLeadingZeros
                                                                                    thousandSeparator=","
                                                                                />
                                                                            </td>
                                                                            <td className={className}>{land.factor}</td>
                                                                            <td className={className}>
                                                                                <NumericFormat
                                                                                    value={land.valuation.toFixed(2)}
                                                                                    displayType={'text'}
                                                                                    prefix={'$'}
                                                                                    allowLeadingZeros
                                                                                    thousandSeparator=","
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            )}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                )}
                                            </div>
                                            <hr className='my-6 border-0'/>
                                            <div className='mb-6'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Construcciones
                                                </Typography>
                                                <table className="w-full min-w-[640px] table-auto border">
                                                    <thead>
                                                    <tr className='bg-gray-50'>
                                                        {["Cve. Valuación", "Descripción", "Sup. Construcción", "Val. Tablas", "Edad", "Fac. Edad", "Valor"].map(
                                                            (el) => (
                                                                <th
                                                                    key={el}
                                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                >
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        {el}
                                                                    </Typography>
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(!constructions || constructions.length === 0) ? (
                                                        <tr className="w-full">
                                                            <td colSpan="100%" className="text-center py-3">
                                                                <strong>El predio no cuenta con
                                                                    construcciones.</strong>
                                                            </td>
                                                        </tr>
                                                    ) : (constructions.map((construction, index) => {
                                                            const className = `py-3 px-5 ${
                                                                index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;
                                                            return (
                                                                <tr key={construction.id}
                                                                    className="hover:bg-gray-50 cursor-pointer">
                                                                    <td className={className}>{construction.construction_value_id}</td>
                                                                    <td className={className}>{construction.description}</td>
                                                                    <td className={className}>
                                                                        <NumericFormat
                                                                            value={construction.construction_area}
                                                                            displayType={'text'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        /> m<sup>2</sup>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <NumericFormat
                                                                            value={construction.value_per_m2}
                                                                            displayType={'text'}
                                                                            prefix={'$'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        />
                                                                    </td>
                                                                    <td className={className}>{construction.construction_devaluation_id}</td>
                                                                    <td className={className}>{construction.devaluation_rate}</td>
                                                                    <td className={className}>
                                                                        <NumericFormat
                                                                            value={construction.valuation}
                                                                            displayType={'text'}
                                                                            prefix={'$'}
                                                                            allowLeadingZeros
                                                                            thousandSeparator=","
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr className='my-6 border-0'/>
                                            <div className="flex grid-cols-3 w-full mt-6 gap-4">
                                                <Card className='w-full border rounded-md bg-gray-50'
                                                      shadow={false}>
                                                    <CardHeader shadow={false} className='my-2 bg-transparent'>
                                                        <Typography
                                                            variant="small"
                                                            color="gray"
                                                            className="font-medium text-center"
                                                        >
                                                            Totales Terreno
                                                        </Typography>
                                                    </CardHeader>
                                                    <CardBody className='pt-4'>
                                                        <div className='flex flex-row gap-4 w-full text-center'>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Sup. Terreno
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    <NumericFormat
                                                                        value={totalLandArea.toFixed(2)}
                                                                        displayType={'text'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    /> {getUnit}
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Val. Terreno
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    <NumericFormat
                                                                        value={totalLandValuation.toFixed(2)}
                                                                        displayType={'text'}
                                                                        prefix={'$'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    />
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                                <Card className='w-full border rounded-md bg-gray-50'
                                                      shadow={false}>
                                                    <CardHeader shadow={false} className='my-2 bg-transparent'>
                                                        <Typography
                                                            variant="small"
                                                            color="gray"
                                                            className="font-medium text-center"
                                                        >
                                                            Totales Construcción
                                                        </Typography>
                                                    </CardHeader>
                                                    <CardBody className='pt-4'>
                                                        <div className='flex flex-row gap-4 w-full text-center'>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Sup. Construcción
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    <NumericFormat
                                                                        value={totalConstArea}
                                                                        displayType={'text'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    /> m<sup>2</sup>
                                                                </Typography>
                                                            </div>
                                                            <div className='flex flex-col w-full'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Val. Construcción
                                                                </Typography>
                                                                <Typography
                                                                    variant="paragraph"
                                                                    className="font-medium"
                                                                >
                                                                    <NumericFormat
                                                                        value={totalConstValuation.toFixed(2)}
                                                                        displayType={'text'}
                                                                        prefix={'$'}
                                                                        allowLeadingZeros
                                                                        thousandSeparator=","
                                                                    />
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                            NOTAS DE MOVIMIENTOS DEL PREDIO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                    >
                                        Notas
                                    </Typography>
                                    <textarea
                                        type="text"
                                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={lotNotes}
                                        onChange={(e) => setLotNotes(e.target.value)}
                                        rows="6"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <Button
                            className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                            onClick={() => handleSubmit()}
                            disabled={loaderActive}
                        >
                            GUARDAR
                        </Button>
                        {
                            error && <p style={{color: "red"}}>{error}</p>
                        }
                    </div>
                </div>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default ValueReduction;
